<template>
  <section>
    <persona-segip-contraste :store="store" :db="db" :change="change"></persona-segip-contraste>
    <v-layout row wrap>
      <v-flex md4>
        <v-text-field
          label="Móvil"
          prepend-icon="smartphone"
          v-model="movil"
          maxlength="30"
          :rules="$validate(['required'])"
          required
          class="required"
          :disabled="!persona"
          ></v-text-field>
      </v-flex>

      <v-flex md4>
        <v-text-field
          label="Teléfono"
          prepend-icon="phone"
          v-model="telefono"
          maxlength="30"
          :disabled="!persona"
          ></v-text-field>
      </v-flex>
      
    </v-layout>
  </section>
</template>

<script>
import PersonaSegipContraste from '@/components/admin/persona/PersonaSegipContraste';
import validate from '@/common/mixins/validate';
import paises from '@/common/mixins/paises';
import { mapFields } from 'vuex-map-fields';

export default {
  mixins: [ validate, paises ],
  props: {
    store: {
      type: String,
      default: ''
    },
    change: {
      type: Boolean,
      default: true
    },
    db: {
      type: Boolean,
      default: false
    }
  },
  created () {
    let items = this.getPaises();
    let paises = [];
    let nacionalidades = [];
    items.map(item => {
      paises.push({ value: item.pais, text: item.pais });
      nacionalidades.push({ value: item.nacionalidad, text: item.nacionalidad });
    });
    this.paises = paises;
    this.nacionalidades = nacionalidades;
  },
  data () {
    return {
      paises: [],
      nacionalidades: [],
      valid: false
    };
  },
  beforeCreate () {
    // Creando campos del formulario en el store definido
    let store = this.$options.propsData.store || '';
    this.$options.computed = {
      ...mapFields([
        'form.nombres',
        'form.primer_apellido',
        'form.segundo_apellido',
        'form.telefono',
        'form.movil',
        'form.nacionalidad',
        'form.pais_nacimiento',
        'form.tipo_documento',
        'form.genero',
        'form.persona'
      ], `${store}getField`, `${store}updateField`)
    };
  },
  components: {
    PersonaSegipContraste
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/persona/PersonaFormContraste.vue